import FileSaver from 'file-saver';
import { api } from '../api';
import * as XLSX from 'xlsx';
import isEmpty from 'lodash/isEmpty';
import useTheme from '@mui/material/styles/useTheme';
import useMediaQuery from '@mui/material/useMediaQuery';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

export const downloadFile = async (url, fileName = 'download') => {
  const blob = await fetch(url).then((r) => r.blob());
  FileSaver.saveAs(blob, fileName);
};

export const getQueryParams = (data) => {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get(data);
};

export const exportToCSV = (
  headerObj = {}, // must contains table Headers Name with there respective keys
  dataArr = [], // must be an array of objects
  fileName = 'download' // file Name
) => {
  if (!isEmpty(dataArr) && !isEmpty(headerObj)) {
    const mappedLogs = dataArr.map((row) => {
      const temp = {};
      Object.entries(row).map((entity) => {
        temp[headerObj[entity[0]]] = entity[1];
      });
      return { ...temp };
    });

    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const ws = XLSX.utils.json_to_sheet(mappedLogs);

    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  }
};

export const responsiveBreakpoints = () => {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));
  const tablet = useMediaQuery(theme.breakpoints.down('md'));
  const laptop = useMediaQuery(theme.breakpoints.down('lg'));
  const desktop = useMediaQuery(theme.breakpoints.up('xl'));
  const mainWidth = useMediaQuery(theme.breakpoints.down('lg'))
    ? `95vw`
    : '1355px';

  return {
    theme,
    mobile,
    tablet,
    laptop,
    desktop,
    mainWidth,
  };
};

export const isWhite = (color) => {
  if (isEmpty(color)) {
    return true;
  }
  const lowerCaseColor = `#${color.toLowerCase()}`;
  return (
    lowerCaseColor === '#ffffff' ||
    lowerCaseColor === '#fff' ||
    lowerCaseColor === '#ffffffff' ||
    lowerCaseColor === '#fffffffff' ||
    lowerCaseColor === '#fffffffffff'
  );
};

// Function to check if the string contains "white"
export const containsWhiteText = (str) => {
  const lowerCaseStr = str.toLowerCase();
  return lowerCaseStr.includes('whit');
};

// check if its json string
export const isJsonString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

// check if entered value exceeds the given value
export const isEnteredValueExceeded = (str, threshold) => {
  if (typeof str === 'string' && typeof threshold == 'number') {
    if (str?.length > threshold) {
      return true;
    } else return false;
  }
};
export const getStateData = async ({ payload }) => {
  const data = await api.get(`getStates/${payload?.country}`);
  return data;
};
export const getCityData = async ({ payload }) => {
  const data = await api.get(`getCities/${payload?.country}/${payload?.state}`);
  return data;
};
export const getCountryData = async () => {
  const data = await api.get(`getCountry`);
  return data;
};
export const validHexCode = (hexCode) => {
  const hexRegex = /^#([a-fA-F0-9]{3}|[a-fA-F0-9]{6})$/;
  return hexRegex.test(hexCode);
};
export const blobUrlToFile = (blobUrl) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous'; // Handle CORS if needed
    img.src = blobUrl;

    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx?.drawImage(img, 0, 0);

      const base64String = canvas.toDataURL('image/png');

      // Convert Base64 to Blob and then to File
      fetch(base64String)
        .then((res) => res.blob())
        .then((blob) => {
          const fileName = 'screenshot.png';
          const fileObj = new File([blob], fileName, { type: blob.type });
          resolve(fileObj); // Resolve the promise with the file object
        })
        .catch((err) => reject(err)); // Reject on any error
    };

    img.onerror = (err) => reject(err); // Handle image load error
  });
};

export const removeHtml = (text) => {
  return (
    text?.replace(/<\/?[^>]+(>|$)/g, '')?.replace(/&[#a-z0-9]+;/gi, '') ?? ''
  );
};

export const generateComponentPDF = async (elementToPrintId, pdfName) => {
  const element = document.getElementById(elementToPrintId);
  if (!element) {
    throw new Error(`Element with id ${elementToPrintId} not found`);
  }

  const elementWidth = element.scrollWidth;
  const elementHeight = element.scrollHeight;

  const scaleFactor = 4;
  const canvas = await html2canvas(element, {
    scale: scaleFactor,
    useCORS: true,
    logging: false,
  });

  const imgData = canvas.toDataURL('image/png');

  const pdfWidth = elementWidth * 0.264583;
  const pdfHeight = elementHeight * 0.264583;

  const pdf = new jsPDF({
    orientation: pdfWidth > pdfHeight ? 'landscape' : 'portrait',
    unit: 'mm',
    format: [pdfWidth, pdfHeight],
  });

  pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight, undefined, 'FAST');

  pdf.save(pdfName || 'high-quality-component.pdf');
};

export const handleAllowOnlyNumber = (e) => {
  const blockedKeys = ['e', 'E', '+', '-', '.'];
  if (blockedKeys.includes(e.key)) {
    e.preventDefault();
  }
};
